import React, { useState, useEffect } from "react";
import ReactFlagsSelect from "react-flags-select";
import { useTranslation } from "react-i18next";

const GBFlag = (props) => (
  <img 
     src="/svg-icon/uk-flag.svg" alt="English" />
);

const DEFlag = (props) => (
  <img 
     src="/svg-icon/germen-flag.svg" alt="German" />
);

const LanguageToggle = ({
  showSelectedLabel = true,
  showOptionLabel = true,
  className,
  selectButtonClassName,
}) => {
  const { i18n } = useTranslation();
  const [selected, setSelected] = useState("DE");

  useEffect(() => {
    if (i18n.language === "en") {
      setSelected("GB");
    } else {
      setSelected("DE");
    }
  }, [i18n.language]);

  const handleLanguageSelect = (code) => {
    setSelected(code);
    const langCode = code == "GB" ? "en" : "de";
    i18n.changeLanguage(langCode);
    localStorage.setItem("lng", langCode);
    // window.location.reload();
  };

  return (
    <>
      <div className={`hidden lg:block ${className || ""}`}>
        <ReactFlagsSelect
          selected={selected}
          onSelect={handleLanguageSelect}
          countries={["GB", "DE"]}
          customLabels={{ GB: "English", DE: "Deutsch" }}
          showSelectedLabel={showSelectedLabel}
          showOptionLabel={showOptionLabel}
          placeholder="Select Language"
          selectButtonClassName={selectButtonClassName}
        />
      </div>
      <div className={`lg:hidden flex items-center gap-3 me-4 ${className || ""}`}>
         {/* Mobile View: Two clickable flags */}
        <button
          onClick={() => handleLanguageSelect("GB")}
          className={`p-0 overflow-hidden rounded-sm transition-transform ${
            selected === "GB" ? "" : ""
          }`}
          aria-label="Select English"
        >
          <GBFlag width="30" height="20" />
        </button>
        <button
          onClick={() => handleLanguageSelect("DE")}
          className={`p-0 overflow-hidden rounded-sm transition-transform ${
            selected === "DE" ? "" : ""
          }`}
          aria-label="Select German"
        >
          <DEFlag width="30" height="20" />
        </button>
      </div>
    </>
  );
};

export default LanguageToggle;
